/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 2076
// module chunks = 0